<template>
    <div class="payInfo">
        <van-row type="flex" justify="center" class="row_icon">
            <van-col span="22" align="center"><van-icon name="checked" color="#F06000" class="payResultIcon"/></van-col>
        </van-row>        
        <van-row type="flex" justify="center" align="center">
            <van-col span="22" align="center" class="payResultText">购买成功</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
            <van-col span="22" align="center" class="payResultTips">
                <p>恭喜您已成功预约，芒果TV全屏会员月卡</p>
                <p>已充值到账户（<span class="userAccount">15200812186</span>）</p>
            </van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
            <van-col span="22" align="center" class="payResultTips2">敬请继续关注商品正式售卖信息<br>2018.08.01至2018.08.12</van-col>
        </van-row>        
    </div>
</template>
<script>
    import Vue from 'vue';
    import { Row, Col,Icon } from 'vant';
    Vue.use(Row).use(Col).use(Icon);
    export default {
        name:"order-success"
        
    }
</script>
<style lang="stylus">
    @import "../share/mixins.styl"
    .payInfo
        padding-top 1rem
        .van-row 
            padding 0
        .row_icon
            height 0.9rem
            .payResultIcon
                font-size 0.9rem
        .payResultText
            font-size 0.48rem
            line-height 0.76rem
            color #F06000
            margin-top 0.46rem
        .payResultTips
            font-size 0.3rem        
            line-height 0.5rem
            .userAccount
                color #F06000
        .payResultTips2
            margin-top 0.6rem
            opacity 0.4
            line-height 0.5rem
</style>



// WEBPACK FOOTER //
// src/pages/OrderSuccess.vue